import { useColorModeValue } from '@chakra-ui/react';

export const useModalStyles = () => {
  // Common Colors
  const bg = useColorModeValue('white', 'gray.800');
  const overlayBg = useColorModeValue('blackAlpha.600', 'blackAlpha.800');
  const borderColor = useColorModeValue('gray.100', 'gray.700');
  
  // Text Colors
  const textColor = useColorModeValue('gray.800', 'gray.100');
  const mutedTextColor = useColorModeValue('gray.500', 'gray.400');
  const labelColor = useColorModeValue('gray.700', 'gray.300');
  
  // Input Styles
  const inputBg = useColorModeValue('gray.50', 'gray.700');
  const inputBorder = useColorModeValue('gray.200', 'gray.600');
  const inputPlaceholder = useColorModeValue('gray.400', 'gray.500');
  const inputFocusBorder = 'blue.500';
  const inputFocusBg = useColorModeValue('white', 'gray.900');
  const inputFocusShadow = '0 0 0 1px #3182ce'; // blue.500

  // Icon Colors
  const iconColor = useColorModeValue('gray.400', 'gray.500');
  const activeIconColor = 'blue.500';

  // Modal Header/Footer
  const headerBg = useColorModeValue('white', 'gray.800');
  const footerBg = useColorModeValue('gray.50', 'gray.900');
  const footerBorderTop = useColorModeValue('gray.100', 'gray.700');

  // Progress Bar / Card
  const progressCardBg = useColorModeValue(
    'linear(to-r, blue.50, purple.50)',
    'linear(to-r, blue.900, purple.900)'
  );
  const progressCardBorder = useColorModeValue('blue.100', 'blue.800');
  const progressTrackBg = useColorModeValue('white', 'gray.700');
  const progressFilledBg = 'linear(to-r, blue.400, purple.500)';

  // Actions
  const ghostButtonHover = useColorModeValue('gray.100', 'gray.700');
  const primaryButtonGradient = 'linear(to-r, blue.400, blue.600)';
  const primaryButtonHover = 'linear(to-r, blue.500, blue.700)';

  // Section Styles
  const sectionBg = useColorModeValue('gray.50', 'gray.900');
  const sectionBorder = useColorModeValue('gray.100', 'gray.700');

  return {
    modal: {
      bg,
      overlayBg,
    },
    text: {
      primary: textColor,
      muted: mutedTextColor,
      label: labelColor,
    },
    input: {
      bg: inputBg,
      borderColor: inputBorder,
      placeholderColor: inputPlaceholder,
      _focus: {
        bg: inputFocusBg,
        borderColor: inputFocusBorder,
        boxShadow: inputFocusShadow,
      },
      group: {
         iconColor,
      }
    },
    progressCard: {
      bgGradient: progressCardBg,
      borderColor: progressCardBorder,
      trackBg: progressTrackBg,
      filledBg: progressFilledBg,
    },
    header: {
      bg: headerBg,
    },
    footer: {
      bg: footerBg,
      borderColor: footerBorderTop,
    },
    section: {
      bg: sectionBg,
      borderColor: sectionBorder,
      dividerColor: borderColor,
    },
    icon: {
      default: iconColor,
      active: activeIconColor,
    },
    button: {
      ghost: {
        _hover: { bg: ghostButtonHover },
      },
      primary: {
        bgGradient: primaryButtonGradient,
        _hover: { bgGradient: primaryButtonHover },
      },
    },
  };
};
